import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import {
  AttendeeSummary,
  CampaignRecipient,
  EmailStatus,
  RewardStatus
} from '../../models/engage/CampaignRecipients.model';

@Injectable({
  providedIn: 'root'
})
export class CampaignDetailsService {
  private campaignRecipients: ReplaySubject<CampaignRecipient[]> = new ReplaySubject<CampaignRecipient[]>();
  private rewardSends: ReplaySubject<number> = new ReplaySubject<number>();
  private emailSends: ReplaySubject<number> = new ReplaySubject<number>();
  private attendeeSummary: ReplaySubject<AttendeeSummary> = new ReplaySubject<AttendeeSummary>();

  public getCampaignRecipients(): Observable<CampaignRecipient[]> {
    return this.campaignRecipients.asObservable()
  }

  public getRewardSends(): Observable<number> {
    return this.rewardSends.asObservable()
  }

  public getEmailSends(): Observable<number> {
    return this.emailSends.asObservable()
  }

  public getAttendeeSummary(): Observable<AttendeeSummary> {
    return this.attendeeSummary.asObservable()
  }

  public setCampaignRecipients(recipients: { recipients: CampaignRecipient[], attendeeSummary: AttendeeSummary }): void {
    this.campaignRecipients.next(recipients.recipients);

    let rewardSends: number = 0;
    let emailSends: number = 0;
    recipients.recipients.forEach((recipient: CampaignRecipient) => {
      switch (recipient.rewardStatus) {
        case RewardStatus.Loaded:
        case RewardStatus.RedeemedIssuedLocation:
        case RewardStatus.RedeemedOtherLocation:
          rewardSends++;
      }
      switch (recipient.emailStatus) {
        case EmailStatus.Delivered:
        case EmailStatus.Opened:
        case EmailStatus.Spam:
        case EmailStatus.Unsubscribed:
          emailSends++;
      }
    });
    this.rewardSends.next(rewardSends);
    this.emailSends.next(emailSends);
    this.attendeeSummary.next(recipients.attendeeSummary);
  }
}
